/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Pizza(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M239.30908,79.9873a16.03867,16.03867,0,0,0-4.22119-21.63085,184.07289,184.07289,0,0,0-214.17578,0A16.03867,16.03867,0,0,0,16.69092,79.9873h.00049l97.81,153.70166a15.99973,15.99973,0,0,0,26.99708,0l58.41259-91.79052c.01807-.0293.0376-.05811.05567-.08789ZM23.44043,75.69238ZM128,225.09912,95.54053,174.09155a36.00171,36.00171,0,1,0-37.55469-59.0144L47.40723,98.45361a135.99256,135.99256,0,0,1,161.18554,0L191.30127,125.626a35.99008,35.99008,0,0,0-38.64453,60.7268Z" />
    </Svg>
  );
}

export default Pizza;
